export default __webpack_public_path__ + "static/media/WOR-styledsystem.372a25e4.png";